'use strict';

exports.__esModule = true;
exports.SuggestionItem = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuggestionItem = exports.SuggestionItem = _propTypes2.default.shape({
    source: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired
}); /* eslint-disable import/prefer-default-export */